module.exports = __webpack_public_path__ + "static/img/product04.ed619f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product04.png
// module id = yfUA
// module chunks = 1